import React from "react";
import styled from "styled-components";

const UnauthorizedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  padding: 40px;
`;

const UnauthorizedTitle = styled.h1`
  font-size: 32px;
  color: #ff4444;
  margin-bottom: 16px;
`;

const UnauthorizedMessage = styled.p`
  font-size: 18px;
  color: #666;
  margin-bottom: 24px;
  max-width: 500px;
  line-height: 1.5;
`;

const BackButton = styled.button`
  padding: 12px 24px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #40a9ff;
  }
`;

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
  userRole?: string;
  isAuthenticated?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
  userRole,
  isAuthenticated = false,
}) => {
  // Check if user is authenticated
  if (!isAuthenticated) {
    return (
      <UnauthorizedContainer>
        <UnauthorizedTitle>Authentication Required</UnauthorizedTitle>
        <UnauthorizedMessage>
          You must be logged in to access this page.
        </UnauthorizedMessage>
        <BackButton onClick={() => (window.location.href = "/access")}>
          Login
        </BackButton>
      </UnauthorizedContainer>
    );
  }

  // Check if user has required role
  if (requiredRole && userRole !== requiredRole) {
    return (
      <UnauthorizedContainer>
        <UnauthorizedTitle>Not authorized</UnauthorizedTitle>
        <UnauthorizedMessage>
          You do not have the required permissions to access this page.
          {requiredRole === "ADMIN" &&
            " This page is restricted to administrators only."}
        </UnauthorizedMessage>
        <BackButton onClick={() => (window.location.href = "/files")}>
          Go to Files
        </BackButton>
      </UnauthorizedContainer>
    );
  }

  // User is authorized, render the protected content
  return <>{children}</>;
};

export default ProtectedRoute;
